import Sections from "components/Contractors/sections";
import {ContractorAddressDetails} from "./ContractorAddressDetails";
import {DetailsColumn} from "components/Shared/CrudComponents";
import React from "react";

export const ContractorCorrespondenceAddress = ({contractor, previousContractor, ...columnProps}) => (
    <DetailsColumn section={Sections.CorrespondenceAddress} {...columnProps}>
        <ContractorAddressDetails address={contractor.correspondenceAddress}
                                  previousAddress={previousContractor && { value: previousContractor.correspondenceAddress}}/>
    </DetailsColumn>
)